import { render } from "./DiskOfferingSelection.vue?vue&type=template&id=e4b76504&scoped=true"
import script from "./DiskOfferingSelection.vue?vue&type=script&lang=js"
export * from "./DiskOfferingSelection.vue?vue&type=script&lang=js"

import "./DiskOfferingSelection.vue?vue&type=style&index=0&id=e4b76504&lang=less&scoped=true"

import exportComponent from "/cloudstack/ui/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e4b76504"]])

export default __exports__